import humanizeString from 'humanize-string';

export function capitalize(string: string): string {
  if (typeof string !== 'string') return '';

  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function getFirstWord(name: string): string {
  const [firstName] = name.split(' ');

  return firstName;
}

export function humanize(string: string): string {
  // TODO: doesn't work on safari.
  return humanizeString(string);
}

export function parseJson<T>(string: string): T | string | undefined {
  let result;
  try {
    result = JSON.parse(string);
  } catch (e) {
    if (e instanceof SyntaxError) {
      return string;
    }
    return undefined;
  }
  return result;
}

export function hideWord(value: string, delimiter = ' ') {
  return value
    .split(delimiter)
    .map((v) => {
      if (v.length < 2) return v;
      return v.substring(0, 1) + '*'.repeat(v.length - 1);
    })
    .join(delimiter);
}
